import { createContext, useContext, useState, useEffect } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";
import { THEMES, getDefaultTheme } from "../lib/themes";

const ThemeCtx = createContext(null);

export function ChildThemeProvider({ children }) {
  const { user, setUser } = useAuth();
  const resolve = () => (user?.theme && THEMES[user.theme] ? user.theme : getDefaultTheme(user?.levels?.lezen || user?.difficulty));
  const [themeId, setThemeId] = useState(resolve());

  useEffect(() => { setThemeId(resolve()); /* eslint-disable-next-line */ }, [user?.theme, user?.difficulty, user?.levels]);

  const setTheme = async (id) => {
    if (!THEMES[id]) return;
    setThemeId(id);
    try {
      const { data } = await api.put("/profile", { theme: id });
      setUser(data);
    } catch { /* keep local */ }
  };

  const theme = THEMES[themeId] || THEMES.arena;
  return <ThemeCtx.Provider value={{ theme, themeId, setTheme, terms: theme.terms }}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);
